import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import NewsIndex from "@/pages/NewsIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/blog/news")({
  head: () => ({
    meta: [
      { title: "Statlign News — Sports Intelligence Newsroom" },
      { name: "keywords", content: seoFor({ topics: ["blog"] }).meta },
      { name: "description", content: "Model updates, market moves and coverage expansion from the Statlign sports intelligence newsroom. Dated, sourced and updated by our editorial team." },
      { property: "og:title", content: "Statlign News — Sports Intelligence Newsroom" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Model updates, market moves and coverage expansion from the Statlign sports intelligence newsroom. Dated, sourced and updated by our editorial team." },
      { name: "twitter:title", content: "Statlign News — Sports Intelligence Newsroom" },
      { name: "twitter:description", content: "Model updates, market moves and coverage expansion from the Statlign sports intelligence newsroom. Dated, sourced and updated by our editorial team." },
    ],
  }),
  component: () => (
    <MainLayout>
      <NewsIndex />
    </MainLayout>
  ),
});
